"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _InfoSlide = require("./InfoSlide");
Object.keys(_InfoSlide).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _InfoSlide[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _InfoSlide[key];
    }
  });
});